module.exports = __webpack_public_path__ + "img/sBus.0953149e.png";